import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { toolbarheight } from "../../theme";
import { footerHeight } from '../Footer/Footer';
import ReportsSidebar from "./ReportsSidebar";
import PbiReportPage from "./EmbeddedPbiReports";
import WaitCursor from "../common/WaitCursor";
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles((theme) => ({
    reportsLayout: {
        display: "flex"
    },
    reportsContent: {
        minHeight: `calc(99.8vh - 8vh - ${toolbarheight} - ${footerHeight})`,
        flex: 1,
        display: "flex",
        overflow: "auto",
        flexDirection: "column",
        '& main': {
            flex: 1,
            padding: 0
        }
    }
}));

const PbiReportsLayout = () => {
    const { t } = useTranslation();
    const classes = useStyles();
    const dispatch = useDispatch();
    //const stableDispatch = useCallback(dispatch, []);
    const [activeReport, setActiveReport] = React.useState(undefined);
    const [sidebarItems, setSideBarItems] = useState([]);
    const userReportsInfo = useSelector(state => state.pbiReportsForUsers);
    

    const menuItems = [];
    function myFunction(value, index) {
        const menuItem = {
            id: index,
            ItemName: value.reportName,
            caption: value.reportName + " " + value.reportId,
            show_caption: true,
            link: "pbiReportPage",
            icon: null,
            sub_menus: []
        }
        menuItems.push(menuItem);
    }
    const SelectReport = (i) => {
        setActiveReport(i);
    }

    useEffect(() => {
        if (!userReportsInfo.isLoading && userReportsInfo.userReports?.length > 0) {
            userReportsInfo.userReports?.forEach(myFunction);
            setSideBarItems(menuItems);
        }

    }, [userReportsInfo.isLoading, userReportsInfo.userReports]);

    return userReportsInfo.isLoading ?
        (
            <WaitCursor />
        )
        :
        (
            <div id="EmbeddedReports" className={classes.reportsLayout}>
                <ReportsSidebar sidebarItems={sidebarItems} SelectReport={SelectReport}/>
                <div className={classes.reportsContent}>
                    <main>
                        {
                            (activeReport !== undefined)  ?
                                <PbiReportPage workspaceId={userReportsInfo.userReports[activeReport]["workspaceId"]} reportId={userReportsInfo.userReports[activeReport]["reportId"]} reportName={userReportsInfo.userReports[activeReport]["reportName"]}></PbiReportPage>
                                :
                                (userReportsInfo.userReports?.length > 0 ?
                                    <div> <p> Please select a report from the left pane</p> </div>
                                    :
                                    <div> <p> No reports Found!!!  Check your log in account</p> </div>
                                )
                        }
                    </main>
                </div>
            </div>
        );
}

export default PbiReportsLayout;

